// Re-export from fast-xml-builder for backward compatibility
import XMLBuilder from 'fast-xml-builder';
export default XMLBuilder;

// If there are any named exports you also want to re-export:
export * from 'fast-xml-builder';